import { render, staticRenderFns } from "./ZhuantiTopBlock.vue?vue&type=template&id=70187636&scoped=true"
import script from "./ZhuantiTopBlock.vue?vue&type=script&lang=js"
export * from "./ZhuantiTopBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhuantiTopBlock.vue?vue&type=style&index=0&id=70187636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70187636",
  null
  
)

export default component.exports